import "./Autocomplete.css"

export default function Autocomplete({ items, itemKey, active, onClick }) {
  return (
    <ul className={`autocomplete ${items.length ? "show" : "hide"}`}>
      {items.map((item, index) => {
        return (
          <li key={item.id.toString()} className={active === index ? "active" : ""} onClick={() => onClick(item[itemKey])}>{item[itemKey]}</li>
        )
      })}
    </ul>
  )
}
